import React from 'react';
import {Box,IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router';

const Message = ({status,color,message,setShowMsg}) => {
    const history=useHistory();
    return (
        <Box  component="div" display="flex" justifyContent="center" alignItems="center" style={{background:color,width:status?"80%":'60%',margin:'0 auto',position:'fixed',top:'0',height:'60px',padding:'0 30px'}}>
            <p style={{color:'#fff',fontSize:'30px',marginRight:'auto',display:"flex",alignItems:"center"}}><p>{message}</p> {
                status? <button style={{background:"blue",marginLeft:"10px",border:"none",color:"#fff",height:"35px",paddingLeft:"15px",paddingRight:"15px"}}  onClick={()=>{history.push("/home")}}>Play again</button>:null
            }</p> 
            <IconButton onClick={()=>setShowMsg(false)}>
              <CloseIcon/>
            </IconButton>
        </Box>
    )
}

export default Message
